import config from './config';

export default function configReducer(state = config) {
  return state;
}
